import React, { Component } from 'react';
import { Card, CardTitle, CardText } from 'react-mdl';

import FontAwesome from 'react-fa';

export default  class Downloads extends Component {
  render() {

    const titleStyle = {
      color: 'white',
      background: "url(/images/blue_circle.jpg) center / cover"
    };

    return (
      <div>
         <Card shadow={0} style={{width: '100%', margin: 'auto'}}>
          <CardTitle style={titleStyle}>SCCC Guidelines & Policies</CardTitle>
          <CardText>
            <a href="https://drive.google.com/file/d/197pf0xi_zHGy5NyfzzYnz6J3VurrHNdZ/view?usp=drivesdk"><FontAwesome name='th-list'/>&nbsp;&nbsp;&nbsp;A Guide to the Role of Our Management Committee</a><br/> 
            <a href="https://drive.google.com/file/d/1XV8w2BxJC1MgrzpBhMhsiHtxaii9mfY7/view?usp=drivesdk"><FontAwesome name='th-list'/>&nbsp;&nbsp;&nbsp;SCCC Image & Video Use Policy</a><br/> 
          </CardText>
        </Card>
        <Card shadow={0} style={{width: '100%', margin: 'auto'}}>
          <CardTitle style={titleStyle}>Preaching Schedule</CardTitle>
          <CardText>
            {/* <a href="http://res.sccc.org.uk/docs/PreachingSchedule2021-Q4.pdf"><FontAwesome name='th-list'/>&nbsp;&nbsp;&nbsp;Upcoming Sermon Schedule</a><br/>  */}
            <FontAwesome name='th-list'/>&nbsp;&nbsp;&nbsp;Upcoming Sermon Schedule  (placeholder) <br/>
          </CardText>
        </Card>
      </div>
    );
  }
}
